<script setup lang="ts">
import Avatar from 'primevue/avatar';
import TextTruncate from '@apparatix/library/TextTruncate.vue';
import type { DetailTabName, ForwardNavigable } from './types';

interface AssociationListItemProps {
  associationType: 'contact' | 'account';
  id?: number;
  title: string;
  subtitle?: string;
  border?: boolean;
  tabId?: DetailTabName;
}

const emit = defineEmits<ForwardNavigable>();

const props = defineProps<AssociationListItemProps>();

</script>
<template>
  <div class="flex flex-col gap-2" :class="[props.border ? 'border-b border-[var(--neutral-background)] pb-2' : '']">
    <div class="flex items-center gap-4">
      <div class="flex-none w-12">
        <Avatar
          v-if="props.associationType === 'contact'"
          icon="pi pi-id-card"
          size="large"
          shape="circle"
          style="background-color: var(--p-fuchsia-100); color: var(--p-fuchsia-500);"
        />
        <Avatar
          v-if="props.associationType === 'account'"
          icon="pi pi-building"
          size="large"
          shape="circle"
          style="background-color: var(--p-teal-100); color: var(--p-teal-500);"
        />
      </div>
      <div class="flex-initial w-72 flex flex-col gap-1 cursor-pointer" @click="emit('navigate-forward', { view: props.associationType, id: props.id, tabId: props.tabId});">
        <TextTruncate :text="props.title" class="text-sm font-medium text-[var(--swimlane-primary-text)] leading-snug" />
        <TextTruncate v-if="props.subtitle" :text="props.subtitle" class="text-xs font-normal text-[var(--swimlane-secondary-text)] leading-snug" />
        <span v-else>&nbsp;</span>
      </div>
      <div class="flex-auto">
        <slot />
      </div>
    </div>
    <slot name="footer" />
  </div>
</template>
